import React from 'react';
import { useTranslation } from 'react-i18next';
import { API_WP_CONTENT_URL } from 'utils/api';

const DisclaimerBox = () => {
	const { t } = useTranslation('homePage');
	const disclaimerLink = t('disclaimerLinkFmt').replace('{}', API_WP_CONTENT_URL);
	const termsLink = t('termsAndConditionsLinkFmt').replace('{}', API_WP_CONTENT_URL);

	return (
		<div className="disclaimer">
			{t('allStatementsWithoutGuarantee')}
			&nbsp;|&nbsp;
			<a href={disclaimerLink}>{t('disclaimer')}</a>
			&nbsp;|&nbsp;
			<a href={termsLink}>{t('termsAndConditions')}</a>
			&nbsp;|&nbsp;
			<a href="#" id="open_preferences_center">
				{t('cookieSettings')}
			</a>
		</div>
	);
};

export default DisclaimerBox;
